import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { computed, type ComputedRef, type Ref } from 'vue';
import { reviewExperienceCards } from '../card/model';
import type { ExperienceReview } from '@/entities/review';
import type { Params } from '../model';
import { normalizeParams } from '../model';

interface UseListReturn {
  reviewsList: ComputedRef<ExperienceReview[]>;
  reviewsCount: ComputedRef<number>;
  isFetched: Ref<boolean>;
}

// Загружает отзывы для листинга и возвращает список вместе с общим количеством из ответа API.
export const useReviewList = (params: Params): UseListReturn => {
  const { getReviews } = useExperienceApi();

  // Сохраняет исходный ответ запроса, чтобы список и счетчик строились из одного источника данных.
  const { data, isFetched } = useQuery({
    queryKey: ['reviewsList', normalizeParams(params)],
    queryFn: () => {
      return getReviews({ query: { ...normalizeParams(params) } });
    },
    retry: false,
  });

  // Приводит API-отзывы к модели карточек и отдельно берет общий счетчик отзывов.
  const reviewsList = computed(() => reviewExperienceCards(data.value?.data?.results) ?? []);
  const reviewsCount = computed(() => data.value?.data?.count ?? 0);

  return {
    isFetched,
    reviewsList,
    reviewsCount,
  };
};
